import { render, staticRenderFns } from "./LiveShare.vue?vue&type=template&id=510056c7&scoped=true"
import script from "./LiveShare.vue?vue&type=script&lang=js"
export * from "./LiveShare.vue?vue&type=script&lang=js"
import style0 from "./LiveShare.vue?vue&type=style&index=0&id=510056c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510056c7",
  null
  
)

export default component.exports